import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import { useRoutes } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";

import routes from "./Router";
import { reactPlugin } from "services/app-insight/app-insight";
import { oidcConfig } from "core/authentication/auth-config";
import { APP_CONSTANTS } from "shared/config/constants";
import { useAuth } from "core/authentication/auth-context";
import { AppSettingsProvider } from "shared/context/AppSettingsContext";
import { appService } from "services";

import "react-toastify/dist/ReactToastify.css";
import "./styles/App.scss";

function App() {
  const { user } = useAuth();
  const routing = useRoutes(routes(user?.isAuthenticated));

  return (
    <>
      <AppSettingsProvider initialSettings={appService.getInitialAppSettings()}>
        <AppInsightsContext.Provider value={reactPlugin}>
          <AuthProvider {...oidcConfig} >
            <HelmetProvider>{routing}</HelmetProvider>
          </AuthProvider>
        </AppInsightsContext.Provider>
        <ToastContainer {...APP_CONSTANTS.toasterConfig} />
      </AppSettingsProvider>
    </>
  );
}

export default App;
